var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Spinner from "../../../shared/Spinner";
export default {
	name: "NoticeToVacateSummary",
	components: { Spinner: Spinner },
	props: {
		resident: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			showNotes: false,
			step: 1,
			modalName: 'notice-to-vacate-summary',
			modifyReason: 'Resident Request',
			addForwarding: false,
			addCharge: false,
			showReletFee: false,
			moveoutReasons: [],
			showLoader: {
				cancelNotice: false,
				updateNotice: false
			},
			noticeEventOriginal: [],
			noticeEvent: {
				notice: {
					id_notice_events: null,
					residentId: null,
					moveout_reason_id: null,
					notify_type: "moveout",
					notify_date: moment().format("MM/DD/YYYY"),
					estimated_moveout_date: "",
					address_one: "",
					address_two: "",
					city: "",
					state: "",
					zip: "",
					pro_rate_transactions: [],
					relet_fee: 0,
					note: '',
					update_reason: ''
				},
				resident: {},
				pro_rate_transactions: [],
				recurring_transactions: []
			},
			terminationType: 'moveout',
			applyProrates: false,
			chargeType: 'credit',
			charges: [],
			accountingChargeCodes: [],
			newTransaction: {
				chargeCode: null,
				amount: null,
				chargeType: 'charge'
			},
			currentRentAmount: 0,
			preventAllPortal: false,
			preventPayPortal: false,
			selectedMoveoutReason: null,
			viewHistory: false,
			today: null,
			stepOneValidations: [{ model: 'noticeEvent.notice.notify_date', rules: 'required | date | before_or_equal:today' }, { model: 'noticeEvent.notice.estimated_moveout_date', rules: 'required | date | after_or_equal:noticeEvent.notice.notify_date' }, { model: 'noticeEvent.notice.note', rules: 'required_if:showNotes' }, { model: 'noticeEvent.relet_fee', rules: 'required_if:showReletFee | integer | min:0' }],
			newTransactionValidations: [{ model: 'newTransaction.amount', rules: 'required | integer | min:0' }, { model: 'newTransaction.chargeCode', rules: 'required' }, { model: 'newTransaction.chargeType', rules: 'required' }]
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.noticeEvent.residentId = this.resident.id;

		Event.$on('close-full-modal', function () {
			Object.assign(_this.$data, _this.$options.data());
			_this.$initValidator();
			_this.cancelMods();
		});

		Event.$on('notice-to-vacate-summary', function () {
			//this.getRecurringTransactions(); On Update notice we don't have to show old recurring transactions
			_this.getAccountingChargeCodes();
			_this.getMoveoutReasons();
			_this.getNoticeEvent(_this.resident.latest_notice_event.id_notice_events);
			_this.today = _this.getCurrentDate();
			Event.$emit('open-slide', _this.modalName);
		});

		Event.$on('cancel-notice-to-vacate', function () {
			_this.today = _this.getCurrentDate();
			_this.cancelNoticeEvent();
		});
	},

	computed: {
		modifiedResidentForwardingAddress: function modifiedResidentForwardingAddress() {
			var address = this.noticeEvent.resident.address_one;
			if (address) {
				return address.concat("<br/>" + (this.noticeEvent.resident.address_two ? this.noticeEvent.resident.address_two + ", " : '') + this.noticeEvent.resident.city, "<br/>" + this.noticeEvent.resident.state + ", " + this.noticeEvent.resident.zip);
			}
			return '';
		},
		residentForwardingAddress: function residentForwardingAddress() {
			var address = this.resident.address_one;
			if (address) {
				return address.concat("<br/>" + (this.resident.address_two ? this.resident.address_two + ", " : '') + this.resident.city, "<br/>" + this.resident.state + ", " + this.resident.zip);
			}
			return '';
		},
		totalTransactions: function totalTransactions() {
			if (!this.noticeEvent.pro_rate_transactions && !this.noticeEvent.relet_fee) return 0;

			var total = 0;
			var relet = this.noticeEvent.relet_fee ? this.noticeEvent.relet_fee : 0;
			this.noticeEvent.pro_rate_transactions.forEach(function (item) {
				total += item.prorated_amount;
			});

			return total + relet;
		},
		notifyDateUpdatedClass: function notifyDateUpdatedClass() {
			var originalNotifyDate = moment(this.resident.latest_notice_event.notify_date).format('L');
			var updatedNotifyDate = moment(this.noticeEvent.notice.notify_date).format('L');
			return !moment(originalNotifyDate).isSame(updatedNotifyDate) ? 'charge-updated' : null;
		},
		moveoutDateUpdatedClass: function moveoutDateUpdatedClass() {
			var originalMoveoutDate = moment(this.resident.latest_notice_event.estimated_moveout_date).format('L');
			var updatedMoveoutDate = moment(this.noticeEvent.notice.estimated_moveout_date).format('L');
			return !moment(originalMoveoutDate).isSame(updatedMoveoutDate) ? 'charge-updated' : null;
		},
		recurringCharges: function recurringCharges() {
			return this.noticeEvent.recurring_transactions.filter(function (item) {
				return item.type === 'Recurring';
			});
		},
		oneTimeCharges: function oneTimeCharges() {
			return this.noticeEvent.pro_rate_transactions.filter(function (item) {
				return item.type === 'One-Time';
			});
		},

		hasOneTimeCharges: function hasOneTimeCharges() {
			return this.oneTimeCharges.length;
		},
		hasRecurringCharges: function hasRecurringCharges() {
			return this.recurringCharges.length;
		}
	},
	methods: {
		addNewCharge: function addNewCharge() {
			this.newTransaction = {
				chargeType: 'charge',
				chargeCode: {}
			};
			this.addCharge = true;
		},
		getCurrentDate: function getCurrentDate() {
			var today = new Date();
			return today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
		},
		getAmountFromChargeCode: function getAmountFromChargeCode(chargeCode) {
			this.newTransaction.amount = chargeCode ? chargeCode.amount : this.newTransaction.amount;
		},

		// @NOTE: this calls <new-resident-slide-out-cancel> with props, one of which is to call `cancel-notice-to-vacate`
		// which will actually cancel the NoticeEvent
		cancel: function cancel() {
			Event.$emit('cancel-notice');
		},
		cancelMods: function cancelMods() {
			Event.$emit('close-slide', this.modalName);
			this.step = 1;
		},
		moveOut: function moveOut() {
			Event.$emit('close-slide', this.modalName);
			Event.$emit('move-out', this.noticeEvent);
		},
		prevStep: function prevStep() {
			Event.$emit('close-slide', this.modalName);
		},

		nextStep: function nextStep() {
			var _this2 = this;

			this.step++;

			// on the modify screen, load the notice event then add increment the step in the promise callback
			if (this.step === 3) {
				this.getNoticeEvent(this.resident.latest_notice_event.id_notice_events).then(function () {
					if (_this2.noticeEvent.relet_fee) {
						_this2.showReletFee = true;
					} else {
						_this2.showReletFee = false;
						_this2.noticeEvent.relet_fee = 0;
					}
				});
				return;
			}

			if (this.step === 4) {
				// On step 3 validating step 4
				this.newTransaction.amount = 0;

				this.validator.setRules(this.stepOneValidations).setCustomMessages({
					'noticeEvent.notice.estimated_moveout_date.after_or_equal': 'This date must be after or equal to the Notification Date.'
				}).validate();

				if (this.validator.fails()) {
					this.step = 3;
					return;
				}

				this.newTransaction.amount = '';
				this.calculateProrates();
			}

			// @TODO - this this is all cruft?
			if (this.step === 5) {
				// @TODO: save this new object
				// named route: 'notice-events.update'

				// @TODO: success message
				//Event.$emit( 'close-slide', this.modalName );
			}
		},
		getNoticeEvent: function getNoticeEvent(noticeEventId) {
			var _this3 = this;

			return axios.get("/prototype/person/residents/notice-events/" + noticeEventId).then(function (response) {
				if (response.data.error) {
					_this3.$snotify.error("Error pulling notice event: " + response.data.error);
				} else {
					_this3.noticeEvent = response.data;
					console.log(_this3.noticeEvent);
					_this3.terminationType = _this3.noticeEvent.notice.notify_type;
					_this3.showReletFee = _this3.noticeEvent.relet_fee ? true : false;
					_this3.noticeEventOriginal = _this3.noticeEvent;
					_this3.noticeEventOriginal.relet_fee_old = _this3.noticeEvent.relet_fee;
					_this3.selectedMoveoutReason = {
						value: _this3.noticeEvent.notice.move_out_reason ? _this3.noticeEvent.notice.move_out_reason.id : -1,
						label: _this3.noticeEvent.notice.move_out_reason ? _this3.noticeEvent.notice.move_out_reason.name : ''
					};
					_this3.noticeEvent.notice.notify_date = moment(_this3.noticeEvent.notice.notify_date).format('MM/DD/YYYY');
					_this3.noticeEvent.notice.estimated_moveout_date = moment(_this3.noticeEvent.notice.estimated_moveout_date).format('MM/DD/YYYY');
					_this3.noticeEvent.notice.updated_at = moment(_this3.noticeEvent.notice.updated_at).format('MM/DD/YYYY');
				}
			});
		},
		getMoveoutReasons: function getMoveoutReasons() {
			var _this4 = this;

			this.moveoutReasons = [];
			axios.get("/api/moveOutReasons").then(function (response) {
				if (response.data.error) {
					_this4.$snotify.error("Error pulling move out reasons: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this4.moveoutReasons.push({
							label: item.name,
							value: item.id
						});
					});
				}
			});
		},
		getRecurringTransactions: function getRecurringTransactions() {
			var _this5 = this;

			this.charges = [];
			axios.post("/prototype/accounting/accounts-receivable/transactions/resident/recurring", {
				id: this.resident.id,
				type: 'current'
			}).then(function (response) {
				if (response.data.error) {
					_this5.$snotify.error("Error pulling recurring transactions: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this5.charges.push({
							ar_transaction_recurring_id: item.id,
							chargeCodeId: item.code.id,
							chargeType: item.is_credit ? 'credit' : 'charge',
							is_debit: item.is_debit,
							name: item.code.name,
							original_amount: item.true_amount,
							is_prorated: false,
							is_new_charge: false,
							amount: null
						});
					});
				}
			});
		},
		cancelNoticeEvent: function cancelNoticeEvent() {
			var _this6 = this;

			this.showLoader.cancelNotice = true;
			axios.delete("/prototype/person/residents/notice-events/" + this.noticeEvent.notice.id_notice_events).then(function (response) {
				_this6.showLoader.cancelNotice = false;
				if (response.data.error) {
					_this6.$snotify.error("Error deleting notice event: " + response.data.error);
				} else {
					Event.$emit('close-slide', _this6.modalName);
					Event.$emit('refresh-resident-dashboard', _this6.resident);
					Event.$emit('resident-list-dashboard-updated');
				}
			});
		},
		addNewTransaction: function addNewTransaction() {
			this.validator.setRules(this.newTransactionValidations).validate();

			if (this.validator.passes()) {
				this.charges.push({
					ar_transaction_recurring_id: null,
					chargeCodeId: this.newTransaction.chargeCode.value,
					chargeType: this.newTransaction.chargeType,
					name: this.newTransaction.chargeCode.label,
					original_amount: this.newTransaction.amount,
					is_prorated: true,
					is_new_charge: true,
					amount: this.newTransaction.amount
				});

				this.newTransaction = { chargeType: 'charge',
					chargeCode: {} };
				this.addCharge = false;
			}
		},
		getAccountingChargeCodes: function getAccountingChargeCodes() {
			var _this7 = this;

			this.accountingChargeCodes = [];
			axios.post("/prototype/accounting/charge-codes/list").then(function (response) {
				if (response.data.error) {
					_this7.$snotify.error("Error pulling accounting charge code: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this7.accountingChargeCodes.push({
							label: item.name,
							value: item.id,
							amount: item.amount === '0.00' ? '' : item.amount
						});
					});
				}
			});
		},
		calculateProrateAmount: function calculateProrateAmount(price) {
			var estimated_moveout_date = moment(this.noticeEvent.notice.estimated_moveout_date, 'MM/DD/YYYY');

			var startOfMonth = estimated_moveout_date.clone();
			startOfMonth = moment(startOfMonth).startOf('month').format('YYYY-MM-DD');

			var days = estimated_moveout_date.diff(startOfMonth, 'days') + 1;
			var daysInMonth = estimated_moveout_date.daysInMonth();
			return (price / daysInMonth * days).toFixed(2);
		},
		calculateProrates: function calculateProrates() {
			var _this8 = this;

			this.charges.map(function (charge) {
				if (charge.ar_transaction_recurring_id) {
					charge.amount = _this8.calculateProrateAmount(charge.original_amount);
				}
			});
		},
		dateFilter: function dateFilter(value) {
			if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
		},
		updateNotice: function updateNotice() {
			var _this9 = this;

			this.noticeEvent.resident.residentId = this.resident.id;
			this.noticeEvent.notice.notify_type = this.terminationType;
			this.noticeEvent.notice.update_reason = this.modifyReason;

			// just a placeholder; we can't update here, so we pull from db now
			this.noticeEvent.pro_rate_transactions = [];
			this.charges.map(function (charge) {
				if (charge.is_prorated) {
					_this9.noticeEvent.pro_rate_transactions.push(charge);
				}
			});
			// // @TODO: we've got our objects mixed up
			this.noticeEvent.notice.pro_rate_transactions = this.noticeEvent.pro_rate_transactions;

			var payload = this.noticeEvent.notice;
			payload['relet_fee'] = this.noticeEvent.relet_fee;

			axios.put("/prototype/person/residents/notice-events/" + this.noticeEvent.notice.id_notice_events, _extends({}, payload, this.noticeEvent.resident)).then(function (response) {
				if (response.data.error) {
					_this9.$snotify.error("Error saving Notice Event: " + response.data.error);
				} else {
					_this9.$snotify.success("Notice Event saved successfully.");
					Event.$emit("close-slide", _this9.modalName);
					Event.$emit('refresh-resident-dashboard');
					Event.$emit('reload-resident');
					Event.$emit('reset-tabs');
					Event.$emit('resident-list-dashboard-updated');
					_this9.step = 1;
					_this9.charges = [];
				}
			});
		},
		updateNoticeEventMoveOutReasonId: function updateNoticeEventMoveOutReasonId(selectedVal) {
			this.noticeEvent.moveout_reason_id = selectedVal ? selectedVal.value : null;
			this.noticeEvent.moveout_reason_lebal = selectedVal ? selectedVal.label : null;
		}
	},
	watch: {
		showReletFee: function showReletFee() {
			if (this.showReletFee) {
				var rent = this.charges.find(function (charge) {
					return charge.name.toLowerCase() === 'rent';
				});
				if (rent) {
					this.currentRentAmount = rent.original_amount;
					if (this.noticeEvent.relet_fee && this.noticeEvent.relet_fee <= 0) {
						this.noticeEvent.relet_fee = (rent.original_amount * .85).toFixed(2);
					}
				}
				if (this.noticeEvent.relet_fee === 'NaN' && typeof this.noticeEvent.relet_fee === 'string') this.noticeEvent.relet_fee = 0;

				this.showNotes = false;
			} else {
				if (this.noticeEvent.notice.notify_type === 'skip' || this.noticeEvent.notice.notify_type === 'eviction') {
					this.showNotes = true;
				}
				this.noticeEvent.relet_fee = 0;
			}
		},
		terminationType: function terminationType() {
			var _label = void 0;

			switch (this.terminationType) {
				case 'skip':
					_label = 'Skipped';
					break;
				case 'eviction':
					_label = 'Eviction';
					break;
				default:
					_label = null;
					break;
			}

			if (_label) {
				var _value = this.moveoutReasons.findIndex(function (r) {
					return r.label.toLowerCase() === _label.toLowerCase();
				});
				if (_value > 0) {
					var _payload = {
						value: this.moveoutReasons[_value].value,
						label: _label
					};

					this.selectedMoveoutReason = _payload;
					this.updateNoticeEventMoveOutReasonId(_payload);
				}
				this.showReletFee = true;
				this.showNotes = this.showReletFee ? false : true;
			} else {
				this.showReletFee = false;
				this.showNotes = false;
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/move-outs/NoticeToVacateSummary.vue
// module id = lr9X
// module chunks = 0 1